export default "__VITE_ASSET__BFSwmdJw__"